import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

/** Keeps existing researcher links working while `/forgot-password` is canonical. */
export const Route = createFileRoute('/researchers/forgot-password')({
  validateSearch: z.object({ email: z.string().optional() }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/forgot-password', search });
  },
});
